const SQRT_3 = Math.sqrt(3);
const HEX_TILE_SIDES = 6;

export { HEX_TILE_SIDES, SQRT_3 };
